import { render, staticRenderFns } from "./UDIOutlistDetailDialog.vue?vue&type=template&id=37f9a8a7&scoped=true"
import script from "./UDIOutlistDetailDialog.vue?vue&type=script&lang=js"
export * from "./UDIOutlistDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9a8a7",
  null
  
)

export default component.exports